import createReducer from "./reducerUtils"
import dataGridModel from 'keys/dataGridModel';
import { produce } from 'immer'
import { cloneDeep, entries } from "lodash";
import { test_taker } from "keys/apis";

const initialState = {
    rowsLoading: {

    },
    visibilityModel: {
        [dataGridModel.test_takers]: {
            id: false,
            test_taker_id: false,
            new_assessment: false,
            tz: false,
            grade_at_registration_name: false,
            languages: false
        },
        [dataGridModel.assessments]: {
            id: false,
            battery_label: false,
            score_fluency: false,
            create_date: false,
            visibility_status: false,
            reading_assessment_affiliation_name: false,
            reading_assessment_name: false,
            factored_percent_accuracy: true,
            paly_audio: false,
            sub_status: false,
            rating_self_correction_and_minor_error_percent: false,
            rating_minor_error_percent: false,
            rating_self_correction_percent: false,
            rating_repetition_percent: false,
            rating_error_percent: false,
            rating_omission_error_and_minor_error_percent: false,
            rating_insertion_percent: false,
            col_ID: false,
            calculations_fluency_reading: false,
            calculations_percent_accuracy: false
        },
        [dataGridModel.assessment_battery]: {
            id: false,
            reading_assessment_title: false,
            battery_label: false,
            reading_assessment_def_id: false,
            audio_file_url: false,
            calculations_percent_accuracy: false,
            print_report: false,
            grade_of_execution_name: false,
            test_taker_affiliation_name: false,
            calculations_percent_accuracy: false,
            calculations_fluency_reading: false,
            prosody: false,
            reading_assessment_affiliation_name: false,
            score_fluency: false,
            rating_insertion_percent: false,
            reading_assessment_affiliation_name: false,
            reading_assessment_name: false,
            factored_percent_accuracy: true,
            paly_audio: false,
            sub_status: false,
            col_ID: false,
            rating_self_correction_and_minor_error_percent: false,
            rating_minor_error_percent: false,
            rating_self_correction_percent: false,
            rating_repetition_percent: false,
            rating_error_percent: false,
            rating_omission_error_and_minor_error_percent: false,
        },
        [dataGridModel.perform_assessments]: {
            preview: false,
            remove: false,
            upload: false,
            test_taker_id: false,
            id: false,
            reading_assessment_def_id: false,
            view_assessment_def: false,
            perform_assessment: false,
            reading_assessment_activated_by: false,
            redo_assessment: false
        },
        [dataGridModel.test_takers_assessments]: {
            test_taker_id: false,
        },
        [dataGridModel.assessment_library]: {
            id: false,
        },
        [dataGridModel.affiliation_test_takers]: {
            id: false,
            test_taker_id: false
        },
        [dataGridModel.affiliation_team]: {
            id: false,
            custom_user_initial_pass: false,
        },
        [dataGridModel.tickets]: {
            id: false,
            last_message_create_date: false
        },
        [dataGridModel.affiliations]: {
            id: false
        },
        [dataGridModel.last_assessments]: {
            id: false,
            grade_at_registration_name: false
        },
        [dataGridModel.admin_assessments]: {
            back_to_marking: false,
            affiliation_name: false,
            cut_audio: false,
            grade: false,
            reading_assessment_grade_of_execution_name: false
        },
        [dataGridModel.users]: {
            id: false,
            status: false,
            initial_pass: false
        }
    }
}

const dataGrid = {
    updateRowsLoading(state, action) {
        let nRowsLoading = { ...state.rowsLoading }
        Object.keys(action.payload).forEach((key) =>
            nRowsLoading[key] = action.payload[key]
        )
        state.rowsLoading = nRowsLoading
    },
    setVisibilityModel(state, action) {
        const { key, value } = action.payload
        let nVisibilityModel = cloneDeep(state.visibilityModel)
        nVisibilityModel[key] = value
        state.visibilityModel = nVisibilityModel
    },
    updateVisibilityModel(state, action) {
        const { key, value } = action.payload
        let nVisibilityModel = cloneDeep(state.visibilityModel)
        const obj = entries(value)
        const keys = obj.map(entry => entry[0]); // Extract keys
        const values = obj.map(entry => entry[1]); //
        nVisibilityModel[key] = { ...nVisibilityModel[key], [keys[0]]: values[0] }
        state.visibilityModel = nVisibilityModel
    },
    setVisibilityModelByKeys(state, action) {
        const { key, value } = action.payload
        let nVisibilityModel = cloneDeep(state.visibilityModel[key])
        Object.keys(value).forEach((fieldKey) => {
            nVisibilityModel[fieldKey] = value[fieldKey]
        })
        state.visibilityModel[key] = nVisibilityModel
    },
}

export default produce(
    (state, action) => createReducer(state, action, dataGrid),
    initialState
)

